export default "/assets/images/mila-feed-04.86b73cd31860bc68.mp4";